import React, { useState } from "react";
import { brand } from "../config/brands";
import Softwarezz from "../assets/softwarezz.png";
import Layout2 from "../component/Layout2";
import AuthService from "../api-library/auth.service";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigate } from "react-router-dom";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");  // Added state for error message

  const navigate = useNavigate(); // hook for navigation

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission

    setShowOverlay(true);
    setErrorMessage(""); // Clear previous error message

    AuthService.login(email, password).then(
      (res) => {
        setShowOverlay(false);
        if (res.Status === "false") {
          setErrorMessage("Invalid login credentials."); // Set error message if login fails
        } else {
          if (res.role === 'ROLE_ADMIN' || res.role === 'ROLE_BUSINESS') {
            // Store user data in AsyncStorage
            AsyncStorage.setItem(
              "myUser",
              JSON.stringify({
                token: res.access_token,
                role: res.role,
                isLoggedIn: true,
                email: email,
              })
            );

            // Navigate to the pending orders page
            navigate("/pending-orders"); // This will navigate to /pending-orders
          } else {
            setErrorMessage("You do not have the necessary permissions to log in."); // Handle invalid role
          }
        }
      },
      (error) => {
        setShowOverlay(false);
        setErrorMessage("An error occurred. Please try again later."); // Handle any errors
      }
    );
  };

  return (
    <Layout2>
      <div className="login-page login-shell flex h-screen">
        {/* Left Section */}
        <div
          className="login-card login-form-panel flex flex-col justify-center items-center w-1/3 bg-gray-100 p-8 rounded-lg shadow-lg"
          style={{ marginLeft: "10%", height: "70%", marginTop: "7%" }}
        >
          <div className="login-form-heading"><img src={brand.logo} alt={`${brand.displayName} logo`} /><p>BACK OFFICE PORTAL</p><h1>Welcome back</h1><span>Sign in to manage your operations.</span></div>

          {/* Form */}
          <form
            onSubmit={handleSubmit} // Handle the form submission here
            className="w-full max-w-sm space-y-6"
          >
            {/* Email */}
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-600"
              >
                Phone number
              </label>
              <input
                type="text"
                id="phone"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your phone Number ..."
                className="mt-1 block w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow focus:border-yellow"
              />
            </div>

            {/* Password */}
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-600"
              >
                Password
              </label>
              <div className="login-password-field"><input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow focus:border-yellow"
              /><button type="button" className="login-password-toggle" onClick={() => setShowPassword(value => !value)} aria-label={showPassword ? "Hide password" : "Show password"} title={showPassword ? "Hide password" : "Show password"}>{showPassword ? <EyeSlashIcon /> : <EyeIcon />}</button></div>
            </div>

            {/* Error Message */}
            {errorMessage && (
              <div className="login-error text-red-600 text-sm mt-2" role="alert">{errorMessage}</div>
            )}

            {/* Sign In Button */}
            <button
              type="submit" // Native form submit button
              className="login-submit w-full py-2 bg-yellow text-white font-medium rounded-lg shadow-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-gray-700"
            >
              {showOverlay ? "Loading..." : "SIGN IN"}
            </button>
          </form>
        </div>

        {/* Right Section */}
        <div
          className="login-brand-panel flex flex-col items-center w-2/3 p-12 bg-white"
          style={{ marginTop: "10%" }}
        >
          <img
            src={Softwarezz}
            alt="Softwarez Logo"
            className="w-48 mb-6"
          />
          <p
            className="text-gray-800 text-sm text-center leading-7 font-inter"
            style={{ fontWeight: "bold" }}
          >
            Step into the heart of your e-commerce operations with our intuitive back office platform. Seamlessly manage your store's activities, from tracking orders to updating inventory, all in one place. Let's dive in and make your online business thrive!
          </p>
        </div>
      </div>
    </Layout2>
  );
};

export default Login;
